import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import ScmInquiries from "./scm/ScmInquiries";
import ScmVendors from "./scm/ScmVendors";
import ScmLeadTimes from "./scm/ScmLeadTimes";

export default function Scm() {
  const [tab, setTab] = useState("inquiries");
  return (
    <div className="p-6" data-testid="scm-page">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-[var(--c-surface)] border border-[var(--c-border)]" data-testid="scm-tabs">
          <TabsTrigger value="inquiries" data-testid="scm-tab-inquiries" className="data-[state=active]:bg-[var(--c-border)] data-[state=active]:text-[var(--c-text)] text-[var(--c-muted)] text-xs">Inquiries</TabsTrigger>
          <TabsTrigger value="vendors" data-testid="scm-tab-vendors" className="data-[state=active]:bg-[var(--c-border)] data-[state=active]:text-[var(--c-text)] text-[var(--c-muted)] text-xs">Vendor Database</TabsTrigger>
          <TabsTrigger value="lead-times" data-testid="scm-tab-lead-times" className="data-[state=active]:bg-[var(--c-border)] data-[state=active]:text-[var(--c-text)] text-[var(--c-muted)] text-xs">Lead Time Dashboard</TabsTrigger>
        </TabsList>
        <TabsContent value="inquiries" className="mt-4"><ScmInquiries /></TabsContent>
        <TabsContent value="vendors" className="mt-4"><ScmVendors /></TabsContent>
        <TabsContent value="lead-times" className="mt-4"><ScmLeadTimes /></TabsContent>
      </Tabs>
    </div>
  );
}
